export default "__VITE_ASSET__B0RWoUXn__"